// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".document-dialog .el-dialog__body{padding:0}.document-dialog .el-dialog__body .document-list{padding:1.5rem 1.25rem 0}.document-dialog .el-dialog__body .document-footer{padding:0 1.25rem 1.25rem}.el-alert-message-warning{background-color:#fdf6ec;padding:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
